<section [ngClass]="dynamicClass">
  <div [ngClass]="{'eq-relative eq-overflow-x-clip': wantBubbles}">
    <div class="{{this.bubblesClass}} {{ underSectionClass}}">
      <div class="eq-container">
        <ng-container *ngIf="!this.injected && !this.parallax">
          <div class="eq-flex eq-flex-col-reverse lg:eq-flex-row eq-items-center" [ngClass]="{'lg:eq-flex-row-reverse': !this.rightImage}">
            <div class="lg:eq-w-1/2">
              <div class="eq-text-center lg:eq-text-start lg:eq-w-4/5" [ngClass]="{'lg:eq-ml-auto': !this.rightImage}">
                <ng-container *ngIf="!rendering?.fields?.H3TitleTag?.value" >
                  <h2 class="eq-mb-5 eq-font-bold eq-text-blue-darkBlue eq-text-heading4-m lg:eq-text-heading4" *scText="rendering.fields.Title"></h2>
                </ng-container>
                <ng-container *ngIf="rendering?.fields?.H3TitleTag?.value" >
                  <h3 class="eq-mb-5 eq-font-bold eq-text-blue-darkBlue eq-text-heading4-m lg:eq-text-heading4" *scText="rendering.fields.Title"></h3>
                </ng-container>
                <div class="eq-mb-7 eq-text-black-natural-60 eq-text-body-m lg:eq-text-body eq-rich-content" *scRichText="rendering.fields.Text"></div>
                <a hybridhref *ngIf="rendering?.fields?.Link?.value?.href" class="eq-btn eq-btn-secondary eq-w-full lg:eq-w-fit"   href="{{rendering?.fields?.Link?.value?.href}}" attr.aria-label="{{rendering?.fields?.Link?.value?.text}}">{{rendering?.fields?.Link?.value?.text}}</a>
              </div>
            </div>
            <div class="eq-mb-5 lg:eq-mb-0 lg:eq-w-1/2 eq-max-h-[710px] eq-overflow-hidden">
              <!-- <img  offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="image?.src" alt="{{ image?.alt }}"> -->
              <img class="eq-object-cover lg:eq-aspect-square" [src]="image?.src" alt="{{ image?.alt }}">
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="this.injected && !this.parallax">
          <div class="eq-flex eq-flex-col lg:eq-flex-row {{bgClassInjected}} eq-mt-[128px]">
            <div class="lg:eq-w-1/2 eq-relative">
              <img class="injectedImage eq-object-cover" [src]="image?.src" alt="{{ image?.alt }}">
            </div>
            <div class="lg:eq-w-1/2">
              <div class="md:eq-pt-[200px]  md:eq-pr-[44px] eq-pb-[44px] eq-pt-[220px]  lg:eq-pt-[100px] lg:eq-pb-[100px] xl:eq-pt-[154px] xl:eq-pr-[122px] xl:eq-pb-[114px]">
                <ng-container *ngIf="!rendering?.fields?.H3TitleTag?.value" >
                  <h2 class="eq-mb-5 eq-font-bold {{bgTextInjected}} eq-text-heading4-m lg:eq-text-heading4 eq-text-blue-darkBlue" *scText="rendering.fields.Title"></h2>
                </ng-container>
                <ng-container *ngIf="rendering?.fields?.H3TitleTag?.value" >
                  <h3 class="eq-mb-5 eq-font-bold {{bgTextInjected}} eq-text-heading4-m lg:eq-text-heading4 eq-text-blue-darkBlue" *scText="rendering.fields.Title"></h3>
                </ng-container>
                <div class="eq-mb-6 lg:eq-mb-7 {{bgTextInjected}} eq-text-body-m lg:eq-text-body eq-text-black-natural-60 eq-rich-content" *scRichText="rendering.fields.Text"></div>
                <a hybridhref *ngIf="rendering?.fields?.Link?.value?.href" class="eq-btn eq-btn-maincta eq-w-full lg:eq-w-fit"   href="{{rendering?.fields?.Link?.value?.href}}" attr.aria-label="{{rendering?.fields?.Link?.value?.text}}">{{rendering?.fields?.Link?.value?.text}}</a>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="this.parallax">
          <div class="eq-flex eq-flex-col lg:eq-flex-row eq-items-center">
            <div class="eq-w-full lg:eq-w-1/2 eq-relative eq-h-[408px] sm:eq-h-[540px] xl:eq-h-auto eq-mb-4 lg:eq-mb-0">
              <!-- Background Image -->
              <img
                [src]="imageParallaxBehind?.src"
                alt="{{imageParallaxBehind?.alt}}"
                class="eq-absolute eq-z-[2] eq-h-[299px] sm:eq-h-[420px] lg:eq-h-[299px] eq-w-[71%] eq-left-[-16px] xl:eq-left-auto xl::eq-w-[509px] xl:eq-h-[544px] xl:eq-top-[-370px] eq-object-cover"
                [ngClass]="{'eq-banner-behind-image-class': !isMobile}"
              />
              <!-- Center Image -->
              <img
                [src]="imageParallaxCenter?.src"
                alt="{{imageParallaxCenter?.alt}}"
                class="eq-absolute eq-z-10 eq-h-[352px] sm:eq-h-[472px] eq-w-[75%] lg:eq-w-[75%] lg:eq-h-[352px] xl:eq-top-[-327px] eq-right-[80px] lg:eq-right-[70px] eq-top-[28px] lg:eq-top-[70px] xl:eq-right-0 eq-object-cover xl:eq-w-[87%] xl:eq-h-[641px]"
                [ngClass]="{'eq-front-image-pan': !isMobile}"
              />
              <!-- Front Image (Overlay in front) -->
              <img 
                [src]="imageParallaxFront?.src"
                alt="{{imageParallaxFront?.alt}}"
                class="eq-absolute eq-z-20 eq-h-[169px] sm:eq-h-[290px] eq-w-[30%] eq-bottom-0 lg:eq-h-[136px] lg:eq-bottom-[32px] eq-right-[23px] lg:eq-right-[60px] xl:eq-w-[30%] xl:eq-h-[230px] xl:eq-right-[-22px] xl:eq-bottom-[-370px]"
                [ngClass]="{'eq-front-image-pan': !isMobile}"
              />
            </div>
            <div class="lg:eq-w-1/2">
              <div class="eq-text-center lg:eq-text-start lg:eq-w-4/5 xl:eq-pt-[228px] xl:eq-pb-[228px] xl:eq-pl-[142px]">
                <ng-container *ngIf="!rendering?.fields?.H3TitleTag?.value" >
                  <h2 class="eq-mb-5 eq-font-bold eq-text-blue-darkBlue eq-text-heading4-m lg:eq-text-heading4" *scText="rendering.fields.Title"></h2>
                </ng-container>
                <ng-container *ngIf="rendering?.fields?.H3TitleTag?.value" >
                  <h3 class="eq-mb-5 eq-font-bold eq-text-blue-darkBlue eq-text-heading4-m lg:eq-text-heading4" *scText="rendering.fields.Title"></h3>
                </ng-container>
                <div class="eq-mb-7 eq-text-black-natural-60 eq-text-body-m lg:eq-text-body eq-rich-content" *scRichText="rendering.fields.Text"></div>
                <a hybridhref *ngIf="rendering?.fields?.Link?.value?.href" class="eq-btn eq-btn-secondary eq-w-full lg:eq-w-fit"   href="{{rendering?.fields?.Link?.value?.href}}" attr.aria-label="{{rendering?.fields?.Link?.value?.text}}">{{rendering?.fields?.Link?.value?.text}}</a>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
